/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExportStatusEntity
 */
export interface ExportStatusEntity {
    /**
     * 
     * @type {string}
     * @memberof ExportStatusEntity
     */
    id?: string;
    /**
     * 
     * @type {Date}
     * @memberof ExportStatusEntity
     */
    dateTime?: Date;
    /**
     * 
     * @type {string}
     * @memberof ExportStatusEntity
     */
    exportType?: string;
    /**
     * 
     * @type {string}
     * @memberof ExportStatusEntity
     */
    personId?: string;
}

export function ExportStatusEntityFromJSON(json: any): ExportStatusEntity {
    return ExportStatusEntityFromJSONTyped(json, false);
}

export function ExportStatusEntityFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExportStatusEntity {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'dateTime': !exists(json, 'dateTime') ? undefined : (new Date(json['dateTime'])),
        'exportType': !exists(json, 'exportType') ? undefined : json['exportType'],
        'personId': !exists(json, 'personId') ? undefined : json['personId'],
    };
}

export function ExportStatusEntityToJSON(value?: ExportStatusEntity | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'dateTime': value.dateTime === undefined ? undefined : (value.dateTime.toISOString()),
        'exportType': value.exportType,
        'personId': value.personId,
    };
}

